import startOfSchoolYear from "../startOfSchoolYear";

const startOfLastSchoolYear = (date = new Date()) => {
  const schoolYear = startOfSchoolYear(date);

  // Substract one year to the date
  schoolYear.setMonth(schoolYear.getMonth() - 12);

  return schoolYear;
};

export default startOfLastSchoolYear;
